module.exports = __webpack_public_path__ + "static/AR1-f45fe29649e3b5df2d4e86b1c45bcc3c.png";